import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import LoadingSpinner from '@zenbusiness/zui/LoadingSpinner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

/** ZenBusiness logo asset path (/s2/vector/zb-mark-black.svg). */
const ZB_LOGO_SRC = '/s2/vector/zb-mark-black.svg';

export default function RestartLoadingStep() {
  return (
    <Stack alignItems="center" justifyContent="center" gap={3} py={15} px={3}>
      <Box position="relative" display="inline-flex">
        <LoadingSpinner size={80} />
        <Box
          position="absolute"
          top={0}
          left={0}
          bottom={0}
          right={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <SharedAsset alt="ZenBusiness" src={ZB_LOGO_SRC} width={36} height={36} />
        </Box>
      </Box>
      <Stack alignItems="center" gap={1}>
        <Text size="2xl" weight="bold" color="secondary">
          <FormattedMessage id="dashboard.subscriptionRestart.loading.title" />
        </Text>
        <Text size="md" color="secondary">
          <FormattedMessage id="dashboard.subscriptionRestart.loading.subtitle" />
        </Text>
      </Stack>
    </Stack>
  );
}
